export const TASK_CLOSED = 'TASK_CLOSED';
